import React from 'react'

import { Box, ThemeProvider } from '@material-ui/core'
import { isEmpty } from 'lodash'

import { RegulationAcceptanceDialog } from 'components'

import defaultTheme from 'theme'
import PortalLoadingScreen from 'views/Guests/components/PortalLoadingScreen'
import useAuthGuest from 'hooks/useAuthGuest'
import useCustomTheme from 'hooks/useCustomTheme'
import useRegulations from 'hooks/useRegulations'
import { TopBar } from './components'
import useStyles from './styles'

const GuestsMainLayout = ({ children }) => {
  const { customTheme } = useCustomTheme()
  const { loaded } = useAuthGuest()
  const activeTheme = isEmpty(customTheme) ? defaultTheme : customTheme

  if (!loaded) return <PortalLoadingScreen />

  return (
    <ThemeProvider theme={activeTheme}>
      <Layout>{children}</Layout>
    </ThemeProvider>
  )
}

const Layout = ({ children }) => {
  const classes = useStyles()
  const { regulationVersions, hasError } = useRegulations()

  return (
    <Box className={classes.root}>
      <TopBar />
      <Box className={classes.content}>
        <Box className={classes.inner}>{children}</Box>
      </Box>
      <RegulationAcceptanceDialog
        open={Boolean(regulationVersions?.[0]) && !hasError}
      />
    </Box>
  )
}

export default GuestsMainLayout
